module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAGZmZv///yH5BAAHAP8ALAAAAAAMAAwAAAIThI+pGu0LGjRyVnhXZmHG7oVLAQA7"